<template>
    <dl class="contact-detail">
        <div v-for="row in rows" :key="row.label" class="contact-detail-row">
            <dt>{{ row.label }}</dt>
            <dd>{{ row.value }}</dd>
        </div>
    </dl>
</template>

<script setup>
import { computed } from "vue";
import { contactLanguageLabel } from "../../helpers/contactLanguage";

const props = defineProps({
    form: { type: Object, required: true },
    locationNames: { type: Array, default: () => [] },
    languageOptions: { type: Array, default: () => [] },
});

const display = (value) => {
    const text = String(value ?? "").trim();
    return text || "no data";
};

const rows = computed(() => [
    { label: "Name", value: display(`${props.form.first_name || ""} ${props.form.last_name || ""}`) },
    { label: "Email", value: display(props.form.emailadres) },
    { label: "Mobile", value: display(props.form.telephone_mobile) },
    { label: "Location phone", value: display(props.form.telephone_location) },
    { label: "Function", value: display(props.form.function) },
    {
        label: "Language",
        value: contactLanguageLabel(props.form.Language, props.languageOptions),
    },
    {
        label: "Monitoring",
        value: props.form.receive_monitoring ? "Yes" : "No",
    },
    {
        label: "Location",
        value: props.locationNames.length
            ? props.locationNames.join(", ")
            : "no data",
    },
]);
</script>

<style scoped lang="scss">
.contact-detail {
    margin: 0;
    display: grid;
    gap: 0.4rem 1.25rem;
}

.contact-detail-row {
    display: grid;
    grid-template-columns: 9rem 1fr;
    gap: 0.5rem;
    align-items: start;
}

dt {
    margin: 0;
    font-size: 0.8rem;
    opacity: 0.75;
}

dd {
    margin: 0;
    word-break: break-word;
}

@media (max-width: 560px) {
    .contact-detail-row {
        grid-template-columns: 1fr;
        gap: 0.15rem;
    }
}
</style>
